// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `page-section-element .element {
  text-align: left;
  height: 100%;
}
page-section-element .element .title {
  font-family: var(--text-font);
  font-weight: bold;
  white-space: normal;
  margin: 0;
}
page-section-element .element .expansion-enabled svg-icon {
  display: none;
  cursor: pointer;
}
page-section-element .element .expansion-enabled svg-icon svg {
  transform-origin: center;
  transition: transform 0.3s;
}
page-section-element .element .expansion-enabled svg-icon .svg-icon {
  font-size: inherit;
}
page-section-element .element .expansion-enabled svg-icon.up svg {
  transform: rotate(0deg);
}
page-section-element .element .expansion-enabled svg-icon.down svg {
  transform: rotate(-180deg);
}
page-section-element .element.redirect {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  margin-bottom: 20px;
}
page-section-element .element.redirect > * {
  max-width: 450px;
}
page-section-element .element.redirect img {
  width: 100%;
  border-radius: 10px;
  margin-bottom: 20px;
}
page-section-element .element.redirect .paragraph {
  flex-grow: 1;
}
page-section-element .element.redirect .paragraph p {
  margin-bottom: 0;
}
page-section-element .element.redirect button {
  width: 70%;
  min-width: -moz-fit-content;
  min-width: fit-content;
}
page-section-element .element.quote {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
  background: var(--motes-white);
  border-radius: 10px;
}
page-section-element .element.quote img {
  border: 2px solid var(--primary-color);
  border-radius: 50%;
  max-height: 12vh;
}
page-section-element .element.quote .title {
  text-align: center;
}
page-section-element .element.quote p {
  margin: var(--motes-padding);
}
page-section-element .side-icon {
  margin-bottom: 1em;
}
page-section-element .side-icon .element p {
  margin-bottom: 0;
}
page-section-element .side-icon svg-icon {
  padding-right: 5%;
}
page-section-element .side-icon svg-icon.stick {
  align-self: flex-start;
}
page-section-element .side-icon svg-icon:not(.stick) {
  align-self: center;
}
page-section-element .top-icon {
  flex-direction: column;
  align-items: center;
  height: calc(100% - 60px);
  padding: 20px;
  color: var(--motes-black);
  background-color: var(--motes-white);
  border-radius: var(--border-radius);
}
page-section-element .top-icon svg-icon {
  padding: 20px 0;
}
page-section-element .top-icon svg-icon .svg-icon {
  font-size: 45px;
}
page-section-element .top-icon .element {
  text-align: center;
}
page-section-element .icon-anchor a {
  display: flex;
}
page-section-element .icon-anchor a .svg-icon {
  display: flex;
  font-size: 24px;
}
page-section-element .icon-paragraph {
  display: flex;
}
page-section-element .icon-paragraph .svg-icon {
  font-size: 35px;
}
@media only screen and (max-width: 600px) {
  page-section-element .element .expansion-enabled {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }
  page-section-element .element .expansion-enabled svg-icon {
    display: initial;
  }
  page-section-element .element p {
    transition: 0.3s max-height;
    overflow: hidden;
  }
  page-section-element .element p.expand {
    max-height: 200px;
  }
  page-section-element .element p.collapse {
    max-height: 0;
  }
  page-section-element .element.redirect {
    margin: 20px 0;
  }
  page-section-element .element .title {
    font-size: 20px;
    line-height: 30px;
  }
  page-section-element .top-icon {
    margin-bottom: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/page-section-element/page-section-element.component.scss"],"names":[],"mappings":"AAEI;EACI,gBAAA;EACA,YAAA;AADR;AAGQ;EACI,6BAAA;EACA,iBAAA;EACA,mBAAA;EACA,SAAA;AADZ;AAIQ;EACI,aAAA;EACA,eAAA;AAFZ;AAIY;EACI,wBAAA;EACA,0BAAA;AAFhB;AAKY;EACI,kBAAA;AAHhB;AAMY;EACI,uBAAA;AAJhB;AAOY;EACI,0BAAA;AALhB;AASQ;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AAPZ;AASY;EACI,gBAAA;AAPhB;AAUY;EACI,WAAA;EACA,mBAAA;EACA,mBAAA;AARhB;AAWY;EACI,YAAA;AAThB;AAUgB;EACI,gBAAA;AARpB;AAYY;EACI,UAAA;EACA,2BAAA;EAAA,sBAAA;AAVhB;AAcQ;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;AAZZ;AAcY;EACI,sCAAA;EACA,kBAAA;EACA,gBAAA;AAZhB;AAeY;EACI,kBAAA;AAbhB;AAgBY;EACI,4BAAA;AAdhB;AAmBI;EACI,kBAAA;AAjBR;AAmBQ;EACI,gBAAA;AAjBZ;AAoBQ;EACI,iBAAA;AAlBZ;AAoBY;EACI,sBAAA;AAlBhB;AAqBY;EACI,kBAAA;AAnBhB;AAwBI;EACI,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,yBAAA;EACA,oCAAA;EACA,mCAAA;AAtBR;AAwBQ;EACI,eAAA;AAtBZ;AAwBY;EACI,eAAA;AAtBhB;AA0BQ;EACI,kBAAA;AAxBZ;AA6BQ;EACI,aAAA;AA3BZ;AA6BY;EACI,aAAA;EACA,eAAA;AA3BhB;AAgCI;EACI,aAAA;AA9BR;AAgCQ;EACI,eAAA;AA9BZ;AAkCI;EAIQ;IACI,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,eAAA;EAnCd;EAqCc;IACI,gBAAA;EAnClB;EAuCU;IACI,2BAAA;IACA,gBAAA;EArCd;EAuCc;IACI,iBAAA;EArClB;EAwCc;IACI,aAAA;EAtClB;EA0CU;IACI,cAAA;EAxCd;EA2CU;IACI,eAAA;IACA,iBAAA;EAzCd;EA6CM;IACI,mBAAA;EA3CV;AACF","sourcesContent":["page-section-element {\n\n    .element {\n        text-align: left;\n        height: 100%;\n\n        .title {\n            font-family: var(--text-font);\n            font-weight: bold;\n            white-space: normal;\n            margin: 0;\n        }\n\n        .expansion-enabled svg-icon {\n            display: none;\n            cursor: pointer;\n            \n            svg {\n                transform-origin: center;\n                transition: transform 0.3s;\n            }\n\n            .svg-icon {\n                font-size: inherit;\n            }\n\n            &.up svg {\n                transform: rotate(0deg);\n            }\n\n            &.down svg {\n                transform: rotate(-180deg);\n            }\n        }\n        \n        &.redirect {\n            display: flex;\n            flex-direction: column;\n            text-align: center;\n            align-items: center;\n            margin-bottom: 20px;\n\n            > * {\n                max-width: 450px;\n            }\n\n            img {\n                width: 100%;\n                border-radius: 10px;\n                margin-bottom: 20px;\n            }\n\n            .paragraph {\n                flex-grow: 1;\n                p {\n                    margin-bottom: 0;\n                }\n            }\n\n            button {\n                width: 70%;\n                min-width: fit-content;\n            }\n        }\n\n        &.quote {\n            display: flex;\n            align-items: center;\n            flex-direction: column;\n            padding: 20px;\n            box-sizing: border-box;\n            background: var(--motes-white);\n            border-radius: 10px;\n\n            img {\n                border: 2px solid var(--primary-color);\n                border-radius: 50%;\n                max-height: 12vh;\n            }\n\n            .title {\n                text-align: center;\n            }            \n\n            p {\n                margin: var(--motes-padding);\n            }\n        } \n    }\n\n    .side-icon {\n        margin-bottom: 1em;\n\n        .element p {\n            margin-bottom: 0;\n        }\n\n        svg-icon {\n            padding-right: 5%;\n\n            &.stick {\n                align-self: flex-start;\n            }\n\n            &:not(.stick) {\n                align-self: center;\n            }\n        }\n    }\n\n    .top-icon {\n        flex-direction: column;\n        align-items: center;\n        height: calc(100% - 60px);\n        padding: 20px;\n        color: var(--motes-black);\n        background-color: var(--motes-white);\n        border-radius: var(--border-radius);\n\n        svg-icon {\n            padding: 20px 0;\n\n            .svg-icon {\n                font-size: 45px;\n            }\n        }\n\n        .element {\n            text-align: center;\n        }\n    }\n\n    .icon-anchor {\n        a {\n            display: flex;\n\n            .svg-icon {\n                display: flex;\n                font-size: 24px;\n            }\n        }\n    }\n\n    .icon-paragraph {\n        display: flex;\n        \n        .svg-icon {\n            font-size: 35px;\n        }\n    }\n\n    @media only screen and (max-width: 600px) {\n\n        .element {\n\n            .expansion-enabled {\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                cursor: pointer;\n    \n                svg-icon {\n                    display: initial;\n                }\n            }\n\n            p {\n                transition: 0.3s max-height;\n                overflow: hidden;\n                \n                &.expand {\n                    max-height: 200px;\n                }\n                \n                &.collapse {\n                    max-height: 0;\n                }\n            }\n\n            &.redirect {\n                margin: 20px 0;\n            }\n\n            .title {\n                font-size: 20px;\n                line-height: 30px;\n            }\n        }\n\n        .top-icon {\n            margin-bottom: 20px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
